import type { AppSettingsType } from '@econtractor/types';

export type TariffRestriction = 'expired' | 'objectLimit' | null;

export const getTariffRestriction = (settings: AppSettingsType | null): TariffRestriction => {
    const account = settings?.account;
    if (!account) return null;
    if (Number(account.tariff) === 0) return 'expired';
    const limit = Number(account.maxObject || 0);
    if (limit > 0 && settings?.objectsCreatedYear != null && settings.objectsCreatedYear >= limit) return 'objectLimit';
    return null;
};
